import { useEffect, useState } from "react";
import { MainTable } from "../../../Components/Macro/MainTable/MainTable";
import Add from "./Add";
import Edit from "./Edit";
import { useAudios } from "./AudioStore";
import { Col, Row } from "antd";
import AudioCat from "../AudioCat/AudioCat";

export const Audios = () => {
    let { videos, columns, setEd, delVideo, setVideo } = useAudios()
    
    let [audios, setAudios] = useState([])
    let [cat, setCat] = useState(0)

    useEffect(() => {
        setVideo()
    }, [])

    useEffect(() => {
        setAudios(videos.filter(v => v.cat_id === cat))
    }, [cat])

    

    return (
        <>
            <Row gutter={25}>
                <Col span={6}>
                    <AudioCat setCat={setCat} />
                </Col>
                <Col span={18}>
                    <MainTable
                        pageTitle={'Audiolar'}
                        pcolumns={columns}
                        pdata={audios}
                        defkey={'id'}
                        add={<Add />}
                        setEd={setEd}
                        edit={<Edit />}
                        onEdit={(data) => {
                            setEd(data)
                        }}
                        onDelete={(_, id) => {
                            delVideo(id)
                        }}
                    />
                </Col>
            </Row>
        </>
    )
}